import { useDictionaryContext } from '3-foundation/Dictionary/DictionaryContext';
import { UI_ContentCardList } from 'ui/components/3-organisms/ContentCardList/ContentCardList';

export const ContactList = ({ content }: Content.ContactList) => {
	const { heading, link, contacts } = content ?? {};
	const dictionary = useDictionaryContext();

	return (
		<UI_ContentCardList
			heading={heading}
			link={{ url: link?.url, name: link?.name, target: link?.target }}
			contentCardItems={contacts?.map((contact) => {
				const { name, title, image, phone, email, contactPersonPageLink } = contact ?? {};
				const contactPhone = phone && `${dictionary?.getContact('Phone')}: ${phone}`;
				const contactEmail = email && `${dictionary?.getContact('Email')}: ${email}`;
				return {
					image: { ...image, altText: '' },
					heading: name,
					text: `${title ? `<p>${title}</p><br/>` : ''}
							${contactEmail ? `<p>${contactEmail}</p>` : ''}
							${contactPhone ? `<p>${contactPhone}</p>` : ''}`,
					link: contactPersonPageLink,
					orientation: 'Vertical',
					displayLinkAs: 'arrowLink',
					headingStyle: 'none',
					padding: 'Slim',
					imageAspectRatio: 'Square',
				};
			})}
			maxNumberOfColumns={4}
		/>
	);
};
